import type { SharedCustomField } from '@/types/serializers';

export type NormalizedCustomField = {
  fieldId: number;
  label: string;
  fieldType:
    | 'number'
    | 'short_text'
    | 'long_text'
    | 'single_select'
    | 'multiple_select'
    | 'date'
    | 'datetime';
  options: Array<{ id: number; value: string; label?: string }>;
  orderNumber: number;
  unitName?: string | null;
};

export type CustomFieldsByCategory = {
  categoryName: string;
  categoryId: number;
  categoryOrderNumber: number;
  customFields: NormalizedCustomField[];
};

/**
 * カスタムフィールドをカテゴリごとに正規化する
 */
export function normalizeCustomFieldsByCategory(
  customFields: SharedCustomField[] | null | undefined
): CustomFieldsByCategory[] {
  if (!customFields || customFields.length === 0) {
    return [];
  }

  // カテゴリごとにグループ化
  const grouped = customFields.reduce(
    (acc, field) => {
      const categoryId = field.custom_category?.id;
      const categoryName = field.custom_category?.name || '';
      const categoryOrderNumber = field.custom_category?.order_number || 0;

      if (!categoryId) {
        return acc;
      }

      if (!acc[categoryId]) {
        acc[categoryId] = {
          categoryName,
          categoryId,
          categoryOrderNumber,
          customFields: [],
        };
      }

      acc[categoryId].customFields.push({
        fieldId: field.id,
        label: field.name,
        fieldType: field.field_type,
        options: field.custom_field_options,
        orderNumber: field.order_number,
        unitName: field.unit_name,
      });

      return acc;
    },
    {} as Record<number, CustomFieldsByCategory>
  );

  // カテゴリのorder_numberでソート
  const sortedCategories = Object.values(grouped).sort(
    (a, b) => a.categoryOrderNumber - b.categoryOrderNumber
  );

  // 各カテゴリ内のフィールドをorder_numberでソート
  return sortedCategories.map((category) => ({
    ...category,
    customFields: category.customFields.sort((a, b) => a.orderNumber - b.orderNumber),
  }));
}
